import { defaultButton, defaultId, defaultStatus, defaultStatusMsg, defaultStyle, defaultTime } from "./shared.js";

// Custom functions for table columns.
const clickButton = (props, params) => {
    props.browser.navigate(`/translations/text/${params.row.id}`);
};

const createTitle = (props, params) => {
    return "View";
};

const disableButton = (props, params) => {
    return params.row.status !== "PROCESSED";
};

// Column definitions.
const resource = (props) => ({
    ...defaultStyle,
    field: "resource.name",
    headerName: "Resource",
    flex: 0.2,
    minWidth: 175,
    valueGetter: (params) => params.row?.resource?.name ?? "N/A"
});
const text = { ...defaultStyle, field: "text", headerName: "Transcript", flex: 0.25, minWidth: 200 };
const language = { ...defaultStyle, field: "language", headerName: "Language", flex: 0.1, minWidth: 100 };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const status = { ...defaultStatus() };
const statusMsg = { ...defaultStatusMsg };
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickButton, disabled: disableButton, title: createTitle }), minWidth: 100, flex: 0.1 };
};

// Table columns.
export const columns = (props) => [defaultId, resource(props), text, language, status, createdOn, updatedOn, statusMsg, action(props)];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
